function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.promise.js";
// components
import Carousel from "Shared/ts/components/carousel";
import Accordion from "Shared/ts/components/accordion";
import FadeCarousel from "Shared/ts/components/fade-carousel";
import ResponsiveCarousel from "Shared/ts/components/responsive-carousel"; // adapters

import SlideCarouselAdapter from "Shared/ts/api/carousel/slide/adapters/slide-carousel";
import FadeSlideCarouselAdapter from "Shared/ts/api/carousel/slide/adapters/fade-slide-carousel";
import ResponsiveSlideCarouselAdapter from "Shared/ts/api/carousel/slide/adapters/responsive-slide-carousel"; // observers

import { observer } from "Shared/ts/observers/intersection";
import MediaQuery from "Shared/ts/observers/media-query"; // utils

import Disclosure from "Shared/ts/utils/disclosure"; // applications

import { initializeBase } from "Shared/ts/applications/template";
import { initializeExpressCheckout, initializeModalDialogIframe, initializeValidateCommon } from "Shared/ts/applications/form";
import StatusScreen from "Shared/ts/components/status-screen";
import { importScrollableHeightByElement, initializeFingerPrintNavBySocialProofElement } from "Shared/ts/applications/navigation";
initializeBase();
var fpn = initializeFingerPrintNavBySocialProofElement();
fpn.hideWhenElementsInView("form");
initializeModalDialogIframe();
initializeValidateCommon();
initializeExpressCheckout();
importScrollableHeightByElement(document.getElementById("scrollable-height"));

var initializeCheckoutForm = () => {
  var validateCommon = initializeValidateCommon();
  if (!validateCommon.form) return;
  var statusScreen = new StatusScreen("checkout-form", validateCommon.form);
  statusScreen.update("Initializing payment options");
  var closeConnection = false;
  var timeout;

  var initializeTimeout = time => setTimeout(() => {
    closeConnection = true;
    clearTimeout(timeout);
    statusScreen.update("Ready for use");
  }, time);

  addEventListener("load", event => initializeTimeout(0));
};

initializeCheckoutForm();
observer(".slide--carousel", {
  inRange: element => {
    var carousel = new Carousel(new SlideCarouselAdapter(element));
    carousel.enablePrevNextControls();
  }
});
observer(".slide--fade", {
  inRange: element => {
    var carousel = new FadeCarousel(new FadeSlideCarouselAdapter(element));
    carousel.setAttributes({
      delay: 7000
    });
    carousel.enablePrevNextControls();
    carousel.autoplay();
  }
});
observer(".accordion", {
  inRange: element => new Accordion(element)
});
var disclosure = new Disclosure();
disclosure.controllers.forEach(controller => {
  controller.addEventListener("click", event => {
    disclosure.toggleElementsByController(controller);
  });
});
observer(".slide--responsive", {
  inRange: element => {
    var carousel = new ResponsiveCarousel(new ResponsiveSlideCarouselAdapter(element));
    carousel.enablePrevNextControls();
    new MediaQuery("(min-width: 600px)").inbound(task => carousel.setAttributes({
      steps: 2
    })).outbound(task => carousel.setAttributes({
      steps: 1
    }));
    new MediaQuery("(min-width: 1000px)").inbound(task => carousel.setAttributes({
      steps: 4
    })).outbound(task => carousel.setAttributes({
      steps: 3
    }));
  }
}); // components

import Countdown from "Shared/ts/components/countdown"; // adapters

import MomentCountdown from "Shared/ts/api/countdown/adapters/moment-countdown";
import Form from "ts/utils/form";
import OfferController from "ts/utils/offer-controller";

var initializeCountdown = () => {
  var countdownElement = document.querySelector(".countdown");
  if (!countdownElement) return;
  var time = countdownElement.getAttribute("data-time");

  if (time) {
    var countdown = new Countdown(countdownElement, new MomentCountdown(time));
    countdown.start();
    countdown.stop(() => {
      countdownElement.classList.add("countdown--is-hidden");
    });
  }
};

initializeCountdown();

class OfferForm extends Form {
  constructor(id) {
    super(id);
    this.initializeOfferRules();
  }

  initializeOfferRules() {
    var _this = this;

    return _asyncToGenerator(function* () {
      var form = yield _this.form;
      var offer = new OfferController(form);
      offer.updateCartOnAction();
      offer.updateCartOnPageLoad();
    })();
  }

  handleNetworkTransaction() {
    var _this2 = this;

    return _asyncToGenerator(function* () {
      var form = yield _this2.form;
      var statusScreen = yield _this2.statusScreen;
      statusScreen.busy("Please wait...");
      form.submit();
    })();
  }

}

new OfferForm("offer-selection");